import React from 'react';
import { FinoptsysLogo, FinoptsysLogoWithATRS } from '../../../styles/svg/svgIcons';

export const FinOptsys = {
  id: 'finOptSys',
  logo: <FinoptsysLogo />,
  logoWithLabel: <FinoptsysLogoWithATRS />,
  showSwapsSmartLink: false,
  adminToolAllow: false,
  renameAllInRateToRepoRate: false,
  login: {
    logo: <FinoptsysLogo />,
    fosLink: true,
    fosLogoAtBottom: true,
    carouselDescription: true,
    disableMfa: true,
  },
  // landingPath: paths.productMenu,
  landingPath: '/',
  navbar: {
    disableThemeSwitch: false,
    disableDefaultHomepage: false,
    disableHelpIcon: false,
    disableDocumentation: true,
    showCookieConsent: false,
  },
  abcPortfolio: {
    defaultColumn: true,
    isFetchAllEntriesConfig: true,
  },
  collateralBasket: {
    fetchBasketItems: {
      optimizedCusipTemplate: false,
    },
    defaultStrategy: {},
    defaultTemplateType: null,
    basketCreationInputField: {
      template: true,
      schedule: false,
      currencies: ['USD', 'GBP', 'EUR', 'CAD', 'JPY', 'AUD', 'CHF'],
      clientRiskTypeTitle: 'Counterparty Profile',
    },
    collateralBasketConstruction: {
      strategy: [],
    },
    collateralBasketNegotiation: {
      customSecurityIdColumn: false,
    },
    useEnrichedSecurityQuery: false,
    // restrictedColDefs: [globalColumnDefinition.runningConcentrationByIssuer, globalColumnDefinition.issuer],
  },
  collateralOptimizationDashboard: {
    title: 'Collateral Optimization Dashboard',
    enableObjectiveWeights: true,
  },
  accountSettings: {
    groups: {
      showTradeType: true,
    },
    clients: {
      isLeDeposAllowed: true,
    },
  },
  repo: {
    tradeTicketButton: false,
  },
  tradeBlotter: {
    orderEntry: {},
    strategy: [
      { id: 'REPO', label: 'REPO', value: 'REPO' },
      { id: 'SBL', label: 'SBL', value: 'SBL' },
      { id: 'OUTRIGHT_CP', label: 'OUTRIGHT CP', value: 'OUTRIGHT_CP' },
      { id: 'OUTRIGHT_TSY', label: 'OUTRIGHT TSY', value: 'OUTRIGHT_TSY' },
    ],
    fieldDecimal: 2,
    allInPriceFieldDecimal: 2,
  },
  dashboardSettings: {
    enableRollTrade: true,
    enableNewCollateralOptDashBoard: true,
    displayCOFticker: true,
    displaySODticker: true,
    startCashColumnExist: true,
    heatMapMessageDisplay: true,
  },
  portfolioUploadConfirm: {
    displayMessage: true,
    displayRestrictedMessage: true,
  },
};
